// API SDK with automatic token refresh
export const API = ((import.meta as any).env?.VITE_API_URL || (typeof window !== "undefined" ? window.location.origin : ""));
const ATK = "handy-jwt-token";
const RTK = "handy-refresh-token";

async function refreshIfNeeded(resp: Response) {
  if (resp.status !== 401) return resp;
  const rtk = localStorage.getItem(RTK);
  if (!rtk) return resp;
  const r = await fetch(`${API}/auth/refresh`, {
    method: "POST", 
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken: rtk }),
  });
  if (!r.ok) return resp;
  const { accessToken } = await r.json();
  localStorage.setItem(ATK, accessToken);
  return new Response(resp.body, resp);
}

export async function api(path: string, init: RequestInit = {}, needAuth = false) {
  const headers: any = { 
    "Content-Type": "application/json", 
    ...(init.headers || {}) 
  };
  
  if (needAuth) {
    const atk = localStorage.getItem(ATK);
    if (atk) headers.Authorization = `Bearer ${atk}`;
  }
  
  let resp = await fetch(`${API}${path}`, { ...init, headers });
  
  if (resp.status === 401 && needAuth) {
    const rtk = localStorage.getItem(RTK);
    if (rtk) {
      // try refresh
      const r = await fetch(`${API}/auth/refresh`, {
        method: "POST", 
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken: rtk }),
      });
      if (r.ok) {
        const { accessToken } = await r.json();
        localStorage.setItem(ATK, accessToken);
        resp = await fetch(`${API}${path}`, { 
          ...init, 
          headers: { 
            ...headers, 
            Authorization: `Bearer ${accessToken}` 
          } 
        });
      }
    }
  }
  
  return resp;
}

export const apiUtils = {
  // 회원가입 (백엔드 엔드포인트와 일치하도록 수정)
  signup: (nickname: string, pin: string) =>
    api('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify({ nickname, pin })
    }),

  // 로그인
  login: (nickname: string, pin: string) =>
    api('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ nickname, pin })
    }),

  // 로그아웃
  logout: () => api('/api/auth/logout', { method: 'POST' }, true),

  // 사용자 정보 조회
  getMe: () => api('/api/auth/me', {}, true),

  // 토큰 갱신
  refreshToken: (refreshToken: string) =>
    api('/api/auth/refresh', {
      method: 'POST',
      body: JSON.stringify({ refreshToken })
    }),

  // 잔고 조회
  getBalance: (address: string) => api(`/wallet/balance/${address}`, {}, true),

  // 트랜잭션 내역 조회
  getTransactions: (address: string, range = 30) => 
    api(`/wallet/transactions/${address}?days=${range}`, {}, true),

  // 토큰 전송
  sendToken: (to: string, amount: string, pin: string) =>
    api('/wallet/send', {
      method: 'POST',
      body: JSON.stringify({ to, amount, pin })
    }, true),

  // 에어드롭 신청
  claimAirdrop: () =>
    api('/auth/airdrop/claim', { method: 'POST' }, true),

  // 이벤트 참여
  participateEvent: (eventId: string) =>
    api('/auth/events/participate', {
      method: 'POST',
      body: JSON.stringify({ eventId })
    }, true),

  // 웰컴 보너스 클레임
  claimWelcomeBonus: () =>
    api('/handy/welcome-bonus/claim', {
      method: 'POST'
    }, true)
};